import React, { useEffect, useRef } from 'react';

import {
  AffittaCasa,
  AffittareOnline,
  AffittareStudentiLavoratori,
  FAQProprietari,
  PercheScegliereZappyrent,
  PubblicaAnnuncioGratis,
} from '.';
import {
  StyledSection,
  StyledSubContainer,
} from '../TextPageLandlord/TextPageLandlord.styles';
import { IComeAffittareCasaProps } from './ComeAffittareCasa.types';

const ComeAffittareCasa = ({
  updateContext,
}: IComeAffittareCasaProps): JSX.Element => {
  const refs = useRef<HTMLElement[]>([]);
  const addToRefs = (refs, element) => {
    if (element && !refs.current.includes(element)) {
      refs.current.push(element);
    }
  };

  useEffect(() => {
    updateContext && updateContext(refs);
  }, [refs, updateContext]);

  return (
    <StyledSubContainer>
      <StyledSection
        id="affitta-casa"
        ref={element => addToRefs(refs, element)}
      >
        <AffittaCasa />
      </StyledSection>
      <StyledSection
        id="pubblica-annuncio-gratis"
        ref={element => addToRefs(refs, element)}
      >
        <PubblicaAnnuncioGratis />
      </StyledSection>
      <StyledSection
        id="affittare-studenti-lavoratori"
        ref={element => addToRefs(refs, element)}
      >
        <AffittareStudentiLavoratori />
      </StyledSection>
      <StyledSection
        id="affittare-online"
        ref={element => addToRefs(refs, element)}
      >
        <AffittareOnline />
      </StyledSection>
      <StyledSection
        id="perche-scegliere-zappyrent"
        ref={element => addToRefs(refs, element)}
      >
        <PercheScegliereZappyrent />
      </StyledSection>
      <StyledSection id="faq" ref={element => addToRefs(refs, element)}>
        <FAQProprietari />
      </StyledSection>
    </StyledSubContainer>
  );
};

export default ComeAffittareCasa;
